import { Injectable } from "@angular/core";
import { Observable, ReplaySubject, Subject } from "rxjs";

import { log } from "rxjslog";

export interface ISearch {
  query: string;
  field: string;
}

interface ISearchInter extends ISearch {
  distinct: boolean;
  firstTime: boolean;
}

@Injectable()
export class SearchProvider {
  public search$: Observable<ISearch>;

  private queryIn$ = new ReplaySubject<string>(1);
  private fieldIn$ = new ReplaySubject<string>(1);

  constructor() {
    this.search$ = Observable.combineLatest(this.queryIn$, this.fieldIn$)
      .startWith(["", ""])
      .map(([query, field]) => ({
        query,
        field,
        distinct: true,
        firstTime: false,
      }))
      .scan<ISearchInter>(
        (acc, value) => {
          return {
            ...value,
            distinct: acc.query !== value.query || acc.firstTime,
            firstTime: false,
          };
        },
        { query: "", field: "", distinct: true, firstTime: true }
      )
      .filter((data) => data.distinct)
      .map((data) => ({ query: data.query, field: data.field }));
  }

  public setQuery(query: string) {
    this.queryIn$.next(query);
  }

  public setField(field: string) {
    this.fieldIn$.next(field);
  }
}



// WEBPACK FOOTER //
// ./src/providers/search/search.ts